import { useEffect, useState } from "react";
import { Loader2, FileText } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const money = (n) => (typeof n === "number" ? n.toLocaleString("pl-PL", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : n);

export function ProformaRegistryAdmin() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/admin/proforma-registry")
      .then((r) => setItems(r.data))
      .catch(() => { setItems([]); toast.error("Nie udało się pobrać rejestru proform."); });
  }, []);

  if (!items) return <div className="flex justify-center py-16"><Loader2 className="animate-spin text-slate-600" /></div>;

  return (
    <div data-testid="proforma-registry-admin" className="space-y-4 max-w-3xl">
      <div className="flex items-start gap-3">
        <FileText className="w-5 h-5 mt-0.5 text-brand-teal shrink-0" />
        <div>
          <h3 className="text-base font-semibold">Rejestr numerów proform</h3>
          <p className="text-sm text-slate-500 mt-1">
            Minimalny rejestr do celów księgowych — tylko numer, data i kwota (bez danych osobowych).
            Zamówienia i pełne proformy nie są przechowywane na serwerze.
          </p>
        </div>
      </div>

      {items.length === 0 ? (
        <div data-testid="proforma-registry-empty" className="text-center py-16 text-muted-foreground text-sm">
          Brak wystawionych proform.
        </div>
      ) : (
        <div className="bg-card border border-border rounded-2xl overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs uppercase tracking-wide text-slate-500 border-b border-border">
                <th className="px-4 py-3 font-semibold">Numer</th>
                <th className="px-4 py-3 font-semibold">Data wystawienia</th>
                <th className="px-4 py-3 font-semibold text-right">Netto (zł)</th>
                <th className="px-4 py-3 font-semibold text-right">Brutto (zł)</th>
              </tr>
            </thead>
            <tbody>
              {items.map((it, i) => (
                <tr key={it.number || i} data-testid={`proforma-row-${i}`} className="border-b border-border/60 last:border-0">
                  <td className="px-4 py-3 font-mono text-xs">{it.number}</td>
                  <td className="px-4 py-3">{it.issued_at}</td>
                  <td className="px-4 py-3 text-right">{money(it.net)}</td>
                  <td className="px-4 py-3 text-right font-semibold">{money(it.gross)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <p className="text-xs text-slate-400" data-testid="proforma-registry-count">Łącznie proform: {items.length}</p>
    </div>
  );
}
